import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import isEmpty from "lodash/isEmpty";
import { pick } from 'lodash'

// CSS
import "../../../css/forms/custom-checkbox.css";
import "../../../css/forms/react-select.css";

// Components
import GeneralLoader from "../../GeneralLoader";
import DeleteConfirmationDialog from "../../utils/dialogs/DeleteConfirmationDialog";
import ErrorWrap from "../../utils/error-success/ErrorWrap";
import SuccessWrap from "../../utils/error-success/SuccessWrap";
import Button from "../../utils/Button";
import BasicInfoFieldset from "./form-components/BasicInfoFieldset";
import NotesFieldset from "./form-components/NotesFieldset";
import LocationFieldset from "./form-components/LocationFieldset";
import MailingLocationFieldset from "./form-components/MailingLocationFieldset";
import ChiefExecFieldset from "./form-components/ChiefExecFieldset";
import AssistantExecFieldset from "./form-components/AssistantExecFieldset";
import ChairpersonFieldset from "./form-components/ChairpersonFieldset";
import SectorsFieldset from "./form-components/SectorsFieldset";

// State
import { userTokenUpdate, userLogout } from "../../../store/actions/user";
import { getLanguages } from "../../../store/actions/languages";
import { getLocations } from "../../../store/actions/locations";
import { getSalutations } from "../../../store/actions/salutations";
import { getSectors } from "../../../store/actions/sectors";
import { getSingleOrganization } from "../../../store/actions/organizations";

// Utils
import { deleteTempImages } from "../../../utils/uploadHelpers";
import { formatMomentString } from "../../../utils/dateHelpers";
import {
	updateSelectedValue,
	handleKeyPress,
	handleInputChange,
	handleInputChangeArray,
	editorChange,
	addPhoneInputToCollection,
	deleteInputFromCollection,
	handleCheckboxClickArray
} from "../../../utils/forms/inputHandling";
import ManagersAlert from "../../utils/ManagersAlert";

class AdminOrganizationsForm extends Component {
	constructor(props) {
		super(props);

		// We need to define all data because it needs to exist for controlled inputs when data is "new"
		this.state = {
			data: {
				id: !!props.match.params.id ? props.match.params.id : null,
				title: "",
				former_title: "",
				cc_notes: "",
				website: "",
				email: "",
				notes: "",
				logo: "",
				operating_expenditure: "0",
				// Chief Exec
				chief_exec_salutation: "",
				chief_exec_fname: "",
				chief_exec_lname: "",
				chief_exec_title: "",
				chief_exec_email: "",
				chief_exec_phone: "",
				chief_exec_phone_extension: "",
				// Assistant Exec
				assistant_exec_fname: "",
				assistant_exec_lname: "",
				assistant_exec_title: "",
				assistant_exec_email: "",
				assistant_exec_phone: "",
				assistant_exec_phone_extension: "",
				// Chairperson
				chairperson_fname: "",
				chairperson_lname: "",
				chairperson_title: "",
				// Location
				address: "",
				address_2: "",
				city: "",
				postal: "",
				province: "",
				// Mailing address
				mailing_address: "",
				mailing_address_2: "",
				mailing_city: "",
				mailing_province: "",
				mailing_postal: "",
				// Sectors
				sectors: [],
				phone_numbers: [{ phone: "", extension: "" }],
				languages: [],
				date_added: null
			},
			isLoading: !!props.match.params.id ? true : false,
			addSucccess: !!props.location.state ? props.location.state.successMessage : "",
			updateLoading: false,
			updateErrors: {},
			updateSuccess: "",
			showDeleteConfirmationDialog: false,
			deletionInProgress: false,
			deleteErrors: "",
			deleteSuccess: "",
			promiseCollection: []
		};

		// Remove state from history object (success messages, etc)
		if (!!props.location.state) {
			props.history.replace({
				pathname: props.history.location.pathname
			});
		}
	}

	// ===================================================================================
	//  LIFE CYCLE
	// ===================================================================================
	componentDidMount() {
		if (this.state.data.id) {
			this.loadData();
		}

		this.props.getLanguages();
		this.props.getLocations();
		this.props.getSalutations();
		this.props.getSectors();
	}

	loadData() {
		this.props.getSingleOrganization(this.state.data.id, true).then(resp => {
			if (resp.data.status === 403) {
				this.props.userLogout("admin");
				return;
			}

			// If no response, bail
			if (!resp || !resp.data) {
				this.setState({ isLoading: false });
				return;
			}

			const data = this.formatRecordData(resp.data);

			// Set the component's data
			this.setState({ data, isLoading: false });
		});
	}

	formatRecordData = data => {
		// Ensure dates are valid
		const date_added = formatMomentString(data.date_added);
		const date_edited = formatMomentString(data.date_edited);

		// React doesn't like it when input elements have values of null, so set them to empty
		Object.keys(data).map(function (key) {
			if (data[key] === null) {
				data[key] = "";
			}

			if (key === "phone_numbers" && !data[key].length) {
				data[key] = [{ phone: "", extension: "" }];
			}

			// Return something just so browser doesn't throw a warning about map not returning anything
			return data[key];
		});

		return { ...data, date_added, date_edited };
	};

	// ===================================================================================
	//  INPUT HANDLING
	// ===================================================================================
	clearPic = () => {
		this.setState({
			data: {
				...this.state.data,
				logo: ""
			}
		});
	};

	// ===================================================================================
	//  SUBMIT
	// ===================================================================================
	handleSubmit = () => {
		this.setState(
			{
				addSucccess: "",
				updateErrors: {},
				updateLoading: true,
				updateSuccess: ""
			},
			() => {
				Promise.all(this.state.promiseCollection)
					.then(resolves => {
						// console.log('ok parent:', resolves)

						this.setState({
							promiseCollection: []
						});

						this.completeSubmit(resolves);
					})
					.catch(err => {
						// console.log('err parent:', err)
						this.setState({
							updateLoading: false,
							promiseCollection: []
						});
					});
			}
		);
	};

	completeSubmit = resolves => {
		const { user } = this.props;

		// Get chunked image results for file.
		// Either array of objects, or null
		const pic = resolves[0]
			? resolves.filter(obj => {
				if (!obj) return false;
				return obj[0].type === "logo";
			})[0]
			: null;

		// Put request data together
		let data = {}
		data = {
						...this.state.data,
						new_pic: !!pic ? pick(pic[0].results, ['dirName', 'filename']) : '',
					}

		// We might need to delete these later
		const uploadedUrls = [];
		if (!!pic) uploadedUrls.push(data.new_pic);

		const token = user.token;
		const AUTH_HEADER = { Authorization: process.env.REACT_APP_SITE_KEY + ":Bearer " + token };
		return axios
			.post(process.env.REACT_APP_API_URL + "organizations", data, {
				headers: AUTH_HEADER
			})
			.then(response => {
				if (!!response.data.token) {
					this.props.userTokenUpdate("admin", response.data.token);
				}

				if (response.data.status === 403) {
					this.props.userLogout("admin");
				} else if (
					response.status !== 200 ||
					(response.data.status && response.data.status !== 200)
				) {
					this.setState({
						updateLoading: false,
						updateErrors: !isEmpty(response.data.errors)
							? response.data.errors
							: { general: response.data.message }
					});

					deleteTempImages(uploadedUrls, this.props.user.token).catch(err => {
						console.log(err);
					});
				} else {

					// Redirect to store edit route
					if (!data.id) {
						this.props.history.push({
							pathname: "/admin/organizations/edit/" + response.data.organization.id,
							state: { successMessage: response.data.message }
						});
						// this.props.history.push({
						// 	pathname: "/admin/organizations/add",
						// 	state: { successMessage: "hello world" }
						// });
						// this.setState({
						// 	updateSuccess: "You have successfully updated an organization!"
						// });

						return;
					}

					// Format record data returned from API
					const updatedRecord = this.formatRecordData(response.data.organization);

					// Staying on this page and all done. So just set some state.
					this.setState({
						data: updatedRecord,
						updateLoading: false,
						updateSuccess: response.data.message
					});
				}
			})
			.catch(err => { //this is where the error is occuring
				if (err.response) {
					this.setState({
						updateLoading: false,
						updateErrors: {
							general: err.response.data.error
								? err.response.data.error
								: err.response.data.message
						}
					});
				} else {
					this.setState({
						updateLoading: false,
						updateErrors: { general: err.message }
					});
				}

				deleteTempImages(uploadedUrls, this.props.user.token).catch(err => {
					console.log(err);
				});
			});
	};

	// ===================================================================================
	//  DELETE
	// ===================================================================================
	handleDelete = () => {
		const { user } = this.props;

		this.setState({
			deletionInProgress: true,
			deleteErrors: {},
			deleteSuccess: ""
		});

		const token = user.token;
		const AUTH_HEADER = { Authorization: process.env.REACT_APP_SITE_KEY + ":Bearer " + token };
		return axios
			.delete(process.env.REACT_APP_API_URL + "organizations/" + this.state.data.id, {
				headers: AUTH_HEADER
			}).then(response => {
				if (!!response.data.token) {
					this.props.userTokenUpdate("admin", response.data.token);
				}

				if (response.data.status === 403) {
					this.props.userLogout("admin");
				} else if (
					response.status !== 200 ||
					(response.data.status && response.data.status !== 200)
				) {
					this.setState({
						updateLoading: false,
						updateErrors: !isEmpty(response.data.errors)
							? response.data.errors
							: { general: response.data.message }
					});


				} else {

					// Redirect to store edit route
					this.props.history.push({
						pathname: "/admin/organizations/"
						// state: { successMessage: response.data.message }
					});
					// this.props.history.push({
					// 	pathname: "/admin/organizations/add",
					// 	state: { successMessage: "hello world" }
					// });
					// this.setState({
					// 	updateSuccess: "You have successfully updated an organization!"
					// });

					return;

					// Format record data returned from API
					// const updatedRecord = this.formatRecordData(response.data.organization);

					// // Staying on this page and all done. So just set some state.
					// this.setState({
					// 	data: updatedRecord,
					// 	updateLoading: false,
					// 	updateSuccess: response.data.message
					// });
				}
			})
		// .then(response => {
		// 	if (!!response.data.token) {
		// 		this.props.userTokenUpdate("admin", response.data.token);
		// 	}

		// 	if (response.data.status === 403) {
		// 		this.props.userLogout("admin");
		// 	} else if (
		// 		response.status !== 200 ||
		// 		(response.data.status && response.data.status !== 200)
		// 	) {
		// 		this.setState({
		// 			deletionInProgress: false,
		// 			deleteErrors: !isEmpty(response.data.errors)
		// 				? response.data.errors
		// 				: response.data.message
		// 		});
		// 	} else {
		// 		this.setState({
		// 			deletionInProgress: false,
		// 			deleteSuccess: response.data.message
		// 		});
		// 	}
		// })
		// .catch(err => {
		// 	if (err.response) {
		// 		this.setState({
		// 			deletionInProgress: false,
		// 			deleteErrors: err.response.data.error
		// 				? err.response.data.error
		// 				: err.response.data.message
		// 		});
		// 	} else {
		// 		this.setState({
		// 			deletionInProgress: false,
		// 			deleteErrors: err.message
		// 		});
		// 	}
		// });
	};

	handleDeleteRedirect() {
		this.props.history.push("/admin/organizations/edit/");
	}

	render() {
		const {
			locationsLoading,
			locationsError,
			provinces,
			salutationsLoading,
			salutationsError,
			salutations,
			sectorsLoading,
			sectorsError,
			sectors,
			languagesLoading,
			languagesError,
			languages
		} = this.props;
		const { data, addSucccess, updateErrors, updateSuccess, updateLoading } = this.state;

		return (
			<React.Fragment>
				{!this.props.match.params.id && <h1>Add Organization</h1>}

				{/* Manager Alert - Won't appear for admins */}
				<ManagersAlert />

				{/* Loading */}
				{this.state.isLoading ? (
					<GeneralLoader />
				) : (
						<React.Fragment>
							{/* Success */}
							{!!addSucccess && <SuccessWrap animate={1}>{addSucccess}</SuccessWrap>}

							{/* General error (record load error) */}
							{!!this.props.recordError && (
								<ErrorWrap animate={1}>{this.props.recordError}</ErrorWrap>
							)}

							{/* Record not found */}
							{!!data.id && !data.title && (
								<ErrorWrap animate={1}>{"Unable to find record"}</ErrorWrap>
							)}

							{/* Show form if adding new item, or item was selected and found */}
							{(!data.id || (data.id && data.title)) && (
								<React.Fragment>
									<BasicInfoFieldset
										data={data}
										errors={updateErrors}
										handleKeyPress={e => handleKeyPress(e, this.handleSubmit)}
										handleInputChange={e => {
											this.setState(handleInputChange(e, this.state));
										}}
										handleCheckboxClickArray={(obj, name) =>
											handleCheckboxClickArray(obj, name, this.state).then(res =>
												this.setState(res)
											)
										}
										addImagePromise={promise =>
											this.state.promiseCollection.push(promise)
										}
										addPhoneInputToCollection={id =>
											addPhoneInputToCollection(id, this.state).then(res =>
												this.setState(res)
											)
										}
										deleteInputFromCollection={(id, name) =>
											deleteInputFromCollection(id, name, this.state).then(res =>
												this.setState(res)
											)
										}
										handleInputChangeArray={(e, index) =>
											handleInputChangeArray(e, index, this.state).then(res =>
												this.setState(res)
											)
										}
										updateSelectedValue={(value, id) => {
											updateSelectedValue(value, id, this.state).then(res =>
												this.setState(res)
											);
										}}
										clearPic={this.clearPic}
										clearImageUploader={this.state.updateSuccess}
										languages={languages}
										languagesError={languagesError}
										languagesLoading={languagesLoading}
										inProcess={updateLoading}
									/>

									<NotesFieldset
										data={data}
										errors={updateErrors}
										editorChange={(id, e) =>
											editorChange(id, e, this.state).then(res =>
												this.setState(res)
											)
										}
										inProcess={updateLoading}
									/>

									<LocationFieldset
										data={data}
										errors={updateErrors}
										handleKeyPress={e => handleKeyPress(e, this.handleSubmit)}
										handleInputChange={e => {
											this.setState(handleInputChange(e, this.state));
										}}
										updateSelectedValue={(value, id) => {
											updateSelectedValue(value, id, this.state).then(res =>
												this.setState(res)
											);
										}}
										provinces={provinces}
										locationsError={locationsError}
										locationsLoading={locationsLoading}
										inProcess={updateLoading}
									/>

									<MailingLocationFieldset
										data={data}
										errors={updateErrors}
										handleKeyPress={e => handleKeyPress(e, this.handleSubmit)}
										handleInputChange={e => {
											this.setState(handleInputChange(e, this.state));
										}}
										updateSelectedValue={(value, id) => {
											updateSelectedValue(value, id, this.state).then(res =>
												this.setState(res)
											);
										}}
										provinces={provinces}
										locationsError={locationsError}
										locationsLoading={locationsLoading}
										inProcess={updateLoading}
									/>

									<ChiefExecFieldset
										data={data}
										errors={updateErrors}
										handleKeyPress={e => handleKeyPress(e, this.handleSubmit)}
										handleInputChange={e => {
											this.setState(handleInputChange(e, this.state));
										}}
										updateSelectedValue={(value, id) => {
											updateSelectedValue(value, id, this.state).then(res =>
												this.setState(res)
											);
										}}
										salutations={salutations}
										salutationsError={salutationsError}
										salutationsLoading={salutationsLoading}
										inProcess={updateLoading}
									/>

									<AssistantExecFieldset
										data={data}
										errors={updateErrors}
										handleKeyPress={e => handleKeyPress(e, this.handleSubmit)}
										handleInputChange={e => {
											this.setState(handleInputChange(e, this.state));
										}}
										updateSelectedValue={(value, id) => {
											updateSelectedValue(value, id, this.state).then(res =>
												this.setState(res)
											);
										}}
										inProcess={updateLoading}
									/>

									<ChairpersonFieldset
										data={data}
										errors={updateErrors}
										handleKeyPress={e => handleKeyPress(e, this.handleSubmit)}
										handleInputChange={e => {
											this.setState(handleInputChange(e, this.state));
										}}
										inProcess={updateLoading}
									/>

									<SectorsFieldset
										data={data}
										errors={updateErrors}
										handleCheckboxClickArray={(obj, name) =>
											handleCheckboxClickArray(
												obj,
												name,
												this.state,
												"sector_id"
											).then(res => this.setState(res))
										}
										sectors={sectors}
										sectorsError={sectorsError}
										sectorsLoading={sectorsLoading}
										inProcess={updateLoading}
									/>

									{this.props.role === 'admin' &&
										<div className="btn_container">
											{!!updateErrors.general && (
												<ErrorWrap animate={1}>{updateErrors.general}</ErrorWrap>
											)}

											{updateSuccess && <SuccessWrap>{updateSuccess}</SuccessWrap>}

											<Button
												text={!!data.id ? "Update" : "Create"}
												clickHandler={this.handleSubmit}
												isLoading={updateLoading}
											/>
											{!!data.id && (
												<Button
													text={"Delete"}
													classes={"delete-btn"}
													clickHandler={() =>
														this.setState({
															showDeleteConfirmationDialog: true
														})
													}
													isLoading={updateLoading}
												/>
											)}
										</div>
									}

									<DeleteConfirmationDialog
										show={this.state.showDeleteConfirmationDialog}
										deletionInProgress={this.state.deletionInProgress}
										id={data.id}
										itemTitle={data.fname}
										handleDelete={this.handleDelete.bind(this)}
										handleDeleteRedirect={this.handleDeleteRedirect.bind(this)}
										handleClose={() =>
											this.setState({ showDeleteConfirmationDialog: false })
										}
										deleteErrors={this.state.deleteErrors}
										deleteSuccess={this.state.deleteSuccess}
									/>
								</React.Fragment>
							)}
						</React.Fragment>
					)}
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.user.admin,
		role: state.user.admin.user.role,
		recordError: state.organizations.errors,
		isLoading: state.user.isLoading,
		provinces: state.locations.provinces,
		locationsLoading: state.locations.isLoading,
		locationsError: state.locations.error,
		salutations: state.salutations.salutations,
		salutationsLoading:
			state.salutations.isLoading !== undefined ? state.salutations.isLoading : true,
		salutationsError: state.salutations.error,
		sectors: state.sectors.sectors,
		sectorsLoading: state.sectors.isLoading !== undefined ? state.sectors.isLoading : true,
		sectorsError: state.sectors.error,
		languages: state.languages.languages,
		languagesLoading:
			state.languages.isLoading !== undefined ? state.languages.isLoading : true,
		languagesError: state.languages.error
	};
};

export default connect(
	mapStateToProps,
	{
		userTokenUpdate,
		userLogout,
		getSingleOrganization,
		getLanguages,
		getLocations,
		getSalutations,
		getSectors
	}
)(AdminOrganizationsForm);



// WEBPACK FOOTER //
// ./src/components/admin/organizations/AdminOrganizationsForm.js